<template>
    <div id="recharge">
        <div>
            <el-card>
                <el-form ref="form" :model="form" label-width="80px" :inline="true" size="small">
                    <el-form-item>
                        <!--                        <el-button type="primary" size="small">查询</el-button>-->
                        <el-button type="primary" size="small" @click="addRecharge">添加规则</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                        :data="tableData"
                        border
                        style="width: 100%">
                    <el-table-column
                            prop="list_order"
                            label="排序">
                    </el-table-column>
                    <el-table-column
                            prop="money"
                            label="充值金额">
                    </el-table-column>
                    <el-table-column
                            prop="smoney"
                            label="赠送金额">
                    </el-table-column>
                    <el-table-column
                            prop="lv"
                            :label="'金额'+this.$store.state.name+'比例'">
                    </el-table-column>
                    <el-table-column
                            prop="apple_id"
                            label="苹果充值appleId">
                    </el-table-column>
                    <el-table-column
                            prop="desc"
                            :width="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'150':''"
                            label="说明">
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            label="是否热门">
                        <template slot-scope="scope">

                            <p style="text-align: center" v-if="scope.row.ishot==1">
                                是
                            </p>
                            <p style="text-align: center" v-if="scope.row.ishot==0">
                                否
                            </p>
                        </template>
                    </el-table-column>
                    <!--                    <el-table-column-->
                    <!--                            prop="address"-->
                    <!--                            label="是否包月">-->
                    <!--                        <template slot-scope="scope">-->
                    <!--                            <p style="text-align: center" v-if="scope.row.ismonth==1">-->
                    <!--                                是-->
                    <!--                            </p>-->
                    <!--                            <p style="text-align: center" v-if="scope.row.ismonth==0">-->
                    <!--                                否-->
                    <!--                            </p>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <!--                    <el-table-column-->
                    <!--                            prop="address"-->
                    <!--                            label="是否半年">-->
                    <!--                        <template slot-scope="scope">-->
                    <!--                            <p style="text-align: center" v-if="scope.row.ishalf==1">-->
                    <!--                                是-->
                    <!--                            </p>-->
                    <!--                            <p style="text-align: center" v-if="scope.row.ishalf==0">-->
                    <!--                                否-->
                    <!--                            </p>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <!--                    <el-table-column-->
                    <!--                            prop="address"-->
                    <!--                            label="是否包年">-->
                    <!--                        <template slot-scope="scope">-->
                    <!--                            <p style="text-align: center" v-if="scope.row.isyear==1">-->
                    <!--                                是-->
                    <!--                            </p>-->
                    <!--                            <p style="text-align: center" v-if="scope.row.isyear==0">-->
                    <!--                                否-->
                    <!--                            </p>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <!--                    <el-table-column-->
                    <!--                            prop="address"-->
                    <!--                            label="是否终身">-->
                    <!--                        <template slot-scope="scope">-->
                    <!--                            <p style="text-align: center" v-if="scope.row.isover==1">-->
                    <!--                                是-->
                    <!--                            </p>-->
                    <!--                            <p style="text-align: center" v-if="scope.row.isover==0">-->
                    <!--                                否-->
                    <!--                            </p>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <el-table-column
                            prop="address"
                            label="是否选中">
                        <template slot-scope="scope">
                            <p style="text-align: center" v-if="scope.row.ischoose==1">
                                是
                            </p>
                            <p style="text-align: center" v-if="scope.row.ischoose==0">
                                否
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            label="状态">
                        <template slot-scope="scope">
                            <p style="text-align: center" v-if="scope.row.isopen==1">
                                是
                            </p>
                            <p style="text-align: center" v-if="scope.row.isopen==0">
                                否
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            label="限制一次">
                        <template slot-scope="scope">
                            <p style="text-align: center" v-if="scope.row.isonce==1">
                                是
                            </p>
                            <p style="text-align: center" v-if="scope.row.isonce==0">
                                否
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            width="150"
                            align="center">
                        <template slot-scope="scope">
                            <el-button type="warning" plain size="small" @click="edit(scope.row.id)">
                                修改
                            </el-button>
                            <el-button type="danger" plain size="small" @click="remove(scope.row.id)">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

            </el-card>
            <!--            新增或编辑-->
            <el-dialog :title="fromTitle" :width="this.$store.state.dialogWidth" :visible.sync="visible">
                <el-row :gutter="20">
                    <el-col :span="this.$store.state.elColNum">
                        <el-form ref="form" :label-width="this.$store.state.labelWidth" size="small">
                            <el-form-item label="充值金额">
                                <el-input v-model="form.money"></el-input>
                            </el-form-item>
                            <el-form-item label="赠送金额">
                                <el-input v-model="form.smoney"></el-input>
                            </el-form-item>
                            <el-form-item :label="'金额'+this.$store.state.name+'比例'">
                                <el-input v-model="form.lv"></el-input>
                            </el-form-item>
                            <el-form-item label="苹果充值appleId">
                                <el-input v-model="form.apple_id"></el-input>
                            </el-form-item>
                            <el-form-item label="说明">
                                <el-input v-model="form.desc"></el-input>
                            </el-form-item>
                            <el-form-item label="是否热门">
                                <el-switch v-model="form.ishot" active-value="1" inactive-value="0"></el-switch>
                            </el-form-item>
                            <!--                            <el-form-item label="是否包月">-->
                            <!--                                <el-switch v-model="form.ismonth" active-value="1" inactive-value="0"></el-switch>-->
                            <!--                            </el-form-item>-->
                            <!--                            <el-form-item label="是否半年">-->
                            <!--                                <el-switch v-model="form.ishalf" active-value="1" inactive-value="0"></el-switch>-->
                            <!--                            </el-form-item>-->
                            <!--                            <el-form-item label="是否包年">-->
                            <!--                                <el-switch v-model="form.isyear" active-value="1" inactive-value="0"></el-switch>-->
                            <!--                            </el-form-item>-->
                            <!--                            <el-form-item label="是否终身">-->
                            <!--                                <el-switch v-model="form.isover" active-value="1" inactive-value="0"></el-switch>-->
                            <!--                            </el-form-item>-->
                            <el-form-item label="是否选中">
                                <el-switch v-model="form.ischoose" active-value="1" inactive-value="0"></el-switch>
                            </el-form-item>
                            <el-form-item label="状态">
                                <el-switch v-model="form.isopen" active-value="1" inactive-value="0"></el-switch>
                            </el-form-item>
                            <el-form-item label="限制一次">
                                <el-switch v-model="form.isonce" active-value="1" inactive-value="0"></el-switch>
                            </el-form-item>
                            <el-form-item label="排序">
                                <el-input v-model="form.list_order"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false" size="small">取 消</el-button>
                <el-button type="primary" @click="dialogAffirm" size="small">确 定</el-button></span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
  export default {
    name: "recharge",
    data() {
      return {
        params: {
          pagenum: 1,
          pagesize: 10,
        },
        form: {
          money: '',
          smoney: '',
          lv: '',
          desc: '',
          ishot: 0,
          ismonth: 0,
          ishalf: 0,
          isyear: 0,
          isover: 0,
          isopen: 0,
          ischoose: 0,
          isonce: 0,
          apple_id: '',
          list_order: ''
        },
        tableData: [],
        value: '100',
        visible: false,
        fromTitle: '',
        id: '',
      }
    },
    created() {
      this.getData();
    },
    methods: {
      viewClick(score) {
        //console.log(score)
      },
      addRecharge() {
        this.form = {
          money: '',
          smoney: '',
          lv: '',
          desc: '',
          ishot: 0,
          ismonth: 0,
          ishalf: 0,
          isyear: 0,
          isover: 0,
          isopen: 0,
          ischoose: 0,
          isonce: 0,
          list_order: ''
        };
        this.keyId = '';
        this.fromTitle = '新增';
        this.visible = true;
      },
      edit(id) {
        this.fromTitle = '修改';
        this.id = id;
        this.$axios.get('admin/charge_rule/' + this.id, '').then((res) => {
          this.form = res.data;
          this.visible = true;
        });
      },
      dialogAffirm() {
        if (this.id) {
          // 编辑
          this.$axios.put('admin/charge_rule/' + this.id, this.form).then((res) => {
            this.$message.success('成功');
            this.getData();
            this.visible = false
          });
        } else {
          // 添加
          this.$axios.post('admin/charge_rule', this.form).then((res) => {
            this.$message.success('成功');
            this.getData();
            this.visible = false
          });
        }
      },
      getData() {
        this.$axios.post('admin/charge_rule/index', {key: 'charge'}).then((res) => {
          let obj = res.data;
          let arr = [];
          for (let key  in obj) {
            Object.assign(obj[key], {keyId: key});
            arr.push(obj[key])
          }
          this.tableData = arr;
        });
      },
      remove(id) {
        this.$confirm('确定要进行操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.del('admin/charge_rule/' + id, '').then((res) => {
            this.$message.success('删除成功!');
            this.getData();
          });
        }).catch(() => {

        });
      }
    }
  }
</script>

<style scoped>

</style>